module.exports = __webpack_public_path__ + "img/manual-receive-01-booking-list.07913587.png";